import React, { Fragment, useContext, useLayoutEffect, useState } from "react";
import {
  BackgroundDiv,
  BottomBtnArea,
  CaptureBtn,
  CaptureBtnArea,
  CardName,
  CardNum,
  ContentBody,
  HeaderTitle,
  ListDiv,
  NoticeText,
  SettingBtn,
  Warapper,
} from "./ReceiptStyle";

import { Button } from "../../../components";
import { AppContext, paymentCfg } from "../../../components/AppProvider";
import { ConfirmLayer } from "../../../components/UI/Dialog";
import ListPayment from "../../../components/UI/List/ListPayment";
import { PostApi1972, PostApi1973 } from "../../../modules/network/padoPost";
import { payment } from "../../../modules/payments/payments";
import { IC, ICON_RED_MINUS_SRC } from "../../../resources/Assets";
import CardIcon, { CardIconImg } from "../../../resources/CardIcon";
import DeleteCard from "../../../resources/images/nftf/cardList/deleteCard.svg";
import Plus from "../../../resources/images/nftf/plus.svg";
import { closeLayerFn, openLayerFn } from "./../../Layout";
import CardEmpty from "../../PayCard/CardEmpty";

const ReceiptCard = props => {
  const {
    cardInfo,
    setCardInfo,
    setPageIdx,
    returnUrl,
    setMoveUrl,
    backStep,
    setBackStep,
    seqNo,
  } = props;
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const [manageMode, setManageMode] = useState(false);
  const [cardList, setCardList] = useState();
  const [deleteTarget, setDeleteTarget] = useState();

  const [cardTemp, setCardTemp] = useState(cardInfo ? cardInfo : null);

  const [activeIdx, setActiveIdx] = useState(0);

  const postUrl = `${cfg.url}app/pg/payment?appUrl=${encodeURIComponent(
    location.origin + returnUrl
  )}&userToken=${userinfo.userToken}`;

  const REACT_APP_MALL_ID = paymentCfg.batchMallId;

  const [webpayParams, setWebayparams] = useState({
    mallId: REACT_APP_MALL_ID,
    payMethodTypeCode: "81",
    currency: "00",
    amount: 0,
    clientTypeCode: "00",
    returnUrl: postUrl,
    shopOrderNo: userinfo.userToken,
    deviceTypeCode: "mobile",
    orderInfo: { goodsName: "비대면진료비" },
    payMethodInfo: {
      billKeyMethodInfo: {
        certType: "0",
      },
    },
  });

  const getMyCardList = () => {
    PostApi1972(userinfo, cfg, phonecfg)
      .then(res => {
        if (res.result.length > 0) {
          let activeCardList = new Array();
          let errCardList = new Array();

          for (let i = 0; i < res.result.length; i++) {
            if (res.result[i].errChkYn === "N") {
              activeCardList.push(res.result[i]);
            } else {
              errCardList.push(res.result[i]);
            }
          }

          let returnCardList = [...activeCardList, ...errCardList];

          setCardList(returnCardList);

          if (!seqNo && !cardInfo) {
            setCardTemp(returnCardList[0]);
          } else {
            if (cardTemp === deleteTarget) {
              setCardTemp(returnCardList[0]);
            }
          }
        } else {
          setCardList([]);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleConfirmDialog = (title, msg, seqNo) => {
    setDialog({
      title: title,
      msg: msg,
    });

    setDeleteTarget(seqNo);
    openLayerFn($(".confirm-layer"));
  };

  const deleteCard = () => {
    PostApi1973(userinfo, cfg, phonecfg, deleteTarget)
      .then(res => {
        if (cardList.length === 1) {
          setCardInfo(null);
          setCardTemp(null);
        }
        getMyCardList();
        setActiveIdx(0);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleCancelCB = () => {
    closeLayerFn($(".confirm-layer"));
  };

  useLayoutEffect(() => {
    getMyCardList();
    props.setMsgState("card");
  }, []);

  const cardSelectEvent = (data, idx) => {
    if (data.errChkYn === "N") {
      // setCardInfo(data);
      setCardTemp(data);
      setActiveIdx(idx);
    } else {
      alert("사용이 불가한 카드입니다.");
    }
  };

  const submit = () => {
    if (cardTemp && cardTemp.errChkYn === "N") {
      setCardInfo(cardTemp);
      // if (backStep) {
      if (seqNo) {
        setPageIdx(1);
      } else {
        // setBackStep(true);
        // setPageIdx(7);
        setPageIdx(10);
      }
    } else {
      alert("결제할 카드를 선택하세요");
    }
  };

  return (
    <Fragment>
      <BackgroundDiv>
        <HeaderTitle>
          <div
            style={{ width: "40px", height: "40px" }}
            // onClick={() => props.setPageIdx(backStep ? 1 : 3)}
            onClick={() =>
              // seqNo ? props.setPageIdx(1) : props.setPageIdx(10)
              seqNo ? props.setPageIdx(1) : props.setPageIdx(10)
            }>
            {/* <img src={ArrowLeft} /> */}
            <img src={IC.etc.ICON_CHEVRON_LEFT} />
          </div>
          {/* <div>결제수단선택</div> */}
          <div>{props.hederTitle}</div>
          <div style={{ width: "40px", height: "40px" }}>
            {/* <img src={ArrowLeft} /> */}
          </div>
        </HeaderTitle>
        <ContentBody>
          <NoticeText>
            진료비 결제카드를
            <br />
            선택해주세요
          </NoticeText>

          <CaptureBtnArea
            style={{
              maxHeight: "40vh",
              overflow: "auto",
              alignItems: "center",
            }}>
            {cardList && cardList.length > 0 ? (
              cardList.map((data, i) => (
                <ListPayment
                  key={"listPayments" + i}
                  data={{
                    // Active: activeIdx === i ? true : false,
                    Active: cardTemp
                      ? cardTemp.seqNo == data.seqNo
                        ? true
                        : false
                      : i == 0
                      ? true
                      : false,
                    Disable: data.errChkYn === "Y" ? true : false,
                    Header: {
                      H_Title: {
                        action: () =>
                          manageMode ? "" : cardSelectEvent(data, i),
                        L_Icon: {
                          img: CardIconImg({
                            cardInfo: {
                              cardCd: data.cardCd,
                            },
                          }),
                        },

                        H_Body: {
                          H_Body_Title: data.cardNm,
                          H_Body_Subs: [
                            {
                              status: "default",
                              text: data.cardNo,
                            },
                            data.errChkYn === "Y" && {
                              status: "error",
                              text: "결제실패",
                            },
                          ],
                        },
                      },

                      R_Icon: {
                        img: manageMode ? ICON_RED_MINUS_SRC : "",
                        action: () =>
                          manageMode
                            ? handleConfirmDialog(
                                "",
                                "선택한 카드를 삭제하시겠습니까?",
                                data.seqNo
                              )
                            : "",
                      },
                    },

                    Body: "",
                  }}
                />
              ))
            ) : (
              <CardEmpty />
            )}
          </CaptureBtnArea>
          <CaptureBtnArea>
            <CaptureBtn
              onClick={() =>
                payment(
                  userinfo,
                  cfg,
                  phonecfg,
                  setMoveUrl,
                  setPageIdx,
                  webpayParams
                )
              }>
              <img src={Plus} style={{ width: "14px", height: "14px" }} />{" "}
              결제수단 추가
            </CaptureBtn>
            <SettingBtn onClick={() => setManageMode(!manageMode)}>
              결제수단 관리
            </SettingBtn>
          </CaptureBtnArea>
        </ContentBody>

        {!manageMode ? (
          <BottomBtnArea>
            <Button
              severity="primary"
              disable={"off"}
              clickEvent={() =>
                cardList && cardList.length > 0
                  ? submit()
                  : props.setViewMsgLayer(true)
              }>
              {backStep ? "저장" : "저장 후 다음"}
            </Button>
          </BottomBtnArea>
        ) : (
          // <BottomBtn onClick={() => setManageMode(!manageMode)}>변경 저장</BottomBtn>
          <BottomBtnArea>
            <Button
              severity="primary"
              disable="off"
              clickEvent={() => setManageMode(!manageMode)}>
              변경 저장
            </Button>
          </BottomBtnArea>
        )}
      </BackgroundDiv>

      <ConfirmLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        handleCancelCB={handleCancelCB}
        handleConfirmCB={deleteCard}
      />
    </Fragment>
  );
};

const CardTemp = (props) => {
  const {
    manageMode,
    cardInfo,
    setCardInfo,
    selectCardData,
    idx,
    handleConfirmDialog,
    checkedOption,
  } = props;

  const [active, setActive] = useState(
    selectCardData ? (selectCardData.seqNo == cardInfo.seqNo ? true : false) : checkedOption
  );

  const toggleEvent = () => {
    setCardInfo(cardInfo);
  };

  return (
    <Warapper>
      <input
        type={manageMode ? "checkbox" : "radio"}
        name="cardList"
        id={"cardList" + cardInfo.seqNo}
        onClick={() =>
          manageMode
            ? handleConfirmDialog("", "선택한 카드를 삭제하시겠습니까?", cardInfo.seqNo)
            : toggleEvent()
        }
        defaultChecked={active}
        hidden
      />
      <ListDiv htmlFor={"cardList" + cardInfo.seqNo}>
        <div>
          <CardIcon cardInfo={cardInfo} />
        </div>
        <div>
          <CardName active={manageMode ? false : $("#cardList" + cardInfo.seqNo).prop("checked")}>
            {cardInfo.cardNm}
          </CardName>
          <CardNum active={manageMode ? false : $("#cardList" + cardInfo.seqNo).prop("checked")}>
            {cardInfo.cardNo}
          </CardNum>
        </div>
        {manageMode && <img src={DeleteCard} style={{ marginLeft: "auto" }} />}
      </ListDiv>
    </Warapper>
  );
};

export default ReceiptCard;
